"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var ImportsApi = /** @class */ (function (_super) {
    __extends(ImportsApi, _super);
    function ImportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to prepare a new import.
     * Prepare new import
     */
    ImportsApi.prototype.actionPrepareNewImportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.PrepareNewImportToJSON(requestParameters.prepareNewImport),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowImportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to prepare a new import.
     * Prepare new import
     */
    ImportsApi.prototype.actionPrepareNewImport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionPrepareNewImportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to queue an export of rows within an import.
     * Export import rows
     */
    ImportsApi.prototype.actionQueueExportRowsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling actionQueueExportRows.');
                        }
                        queryParameters = {};
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}/rows/queue".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to queue an export of rows within an import.
     * Export import rows
     */
    ImportsApi.prototype.actionQueueExportRows = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionQueueExportRowsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to reupload a file for the given import after validating it.  This is useful if you\'ve started an import but it had validation errors.
     * Reupload an import
     */
    ImportsApi.prototype.actionReuploadImportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling actionReuploadImport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}/reupload".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReuploadImportToJSON(requestParameters.reuploadImport),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowImportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to reupload a file for the given import after validating it.  This is useful if you\'ve started an import but it had validation errors.
     * Reupload an import
     */
    ImportsApi.prototype.actionReuploadImport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionReuploadImportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to roll-back the given import after validating it
     * Roll back an import
     */
    ImportsApi.prototype.actionRollBackImportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling actionRollBackImport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}/rollback".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowImportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to roll-back the given import after validating it
     * Roll back an import
     */
    ImportsApi.prototype.actionRollBackImport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionRollBackImportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to start the given import after validating it.  You must validate the import first. You can do this with the [`actionPrepareNewImport`](/endpoints/Imports#actionPrepareNewImport) operation.  You won\'t be able to start the import if there were any validation errors.
     * Start an import
     */
    ImportsApi.prototype.actionStartImportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling actionStartImport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}/start".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowImportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to start the given import after validating it.  You must validate the import first. You can do this with the [`actionPrepareNewImport`](/endpoints/Imports#actionPrepareNewImport) operation.  You won\'t be able to start the import if there were any validation errors.
     * Start an import
     */
    ImportsApi.prototype.actionStartImport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionStartImportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve an `Import` by its ID.
     * Show an Import
     */
    ImportsApi.prototype.getImportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling getImport.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowImportFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve an `Import` by its ID.
     * Show an Import
     */
    ImportsApi.prototype.getImport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getImportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a file template which you can use for [preparing a new import](/endpoints/Imports#actionPrepareNewImport)
     * Get a template
     */
    ImportsApi.prototype.getTemplateRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.templateName === null || requestParameters.templateName === undefined) {
                            throw new runtime.RequiredError('templateName', 'Required parameter requestParameters.templateName was null or undefined when calling getTemplate.');
                        }
                        queryParameters = {};
                        if (requestParameters.templateName !== undefined) {
                            queryParameters['templateName'] = requestParameters.templateName;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/templates",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a file template which you can use for [preparing a new import](/endpoints/Imports#actionPrepareNewImport)
     * Get a template
     */
    ImportsApi.prototype.getTemplate = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTemplateRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this endpoint to list the rows within an import and their status.  Once an import has been validated, you can inspect the rows within it to see what\'s going to be imported and what might need to be fixed.
     * List import rows
     */
    ImportsApi.prototype.listImportRowsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.importId === null || requestParameters.importId === undefined) {
                            throw new runtime.RequiredError('importId', 'Required parameter requestParameters.importId was null or undefined when calling listImportRows.');
                        }
                        queryParameters = {};
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports/{importId}/rows".replace("{" + "importId" + "}", encodeURIComponent(String(requestParameters.importId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListImportRowsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to list the rows within an import and their status.  Once an import has been validated, you can inspect the rows within it to see what\'s going to be imported and what might need to be fixed.
     * List import rows
     */
    ImportsApi.prototype.listImportRows = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listImportRowsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list of `Import` entities.
     * List imports
     */
    ImportsApi.prototype.listImportsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling listImports.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/imports",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListImportsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list of `Import` entities.
     * List imports
     */
    ImportsApi.prototype.listImports = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listImportsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ImportsApi;
}(runtime.BaseAPI));
exports.ImportsApi = ImportsApi;
/**
    * @export
    * @enum {string}
    */
var ActionQueueExportRowsStatusEnum;
(function (ActionQueueExportRowsStatusEnum) {
    ActionQueueExportRowsStatusEnum["Validating"] = "validating";
    ActionQueueExportRowsStatusEnum["Validated"] = "validated";
    ActionQueueExportRowsStatusEnum["Importing"] = "importing";
    ActionQueueExportRowsStatusEnum["Imported"] = "imported";
    ActionQueueExportRowsStatusEnum["RollingBack"] = "rolling_back";
    ActionQueueExportRowsStatusEnum["RolledBack"] = "rolled_back";
    ActionQueueExportRowsStatusEnum["Errored"] = "errored";
})(ActionQueueExportRowsStatusEnum = exports.ActionQueueExportRowsStatusEnum || (exports.ActionQueueExportRowsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetTemplateTemplateNameEnum;
(function (GetTemplateTemplateNameEnum) {
    GetTemplateTemplateNameEnum["Client"] = "client";
})(GetTemplateTemplateNameEnum = exports.GetTemplateTemplateNameEnum || (exports.GetTemplateTemplateNameEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ListImportRowsStatusEnum;
(function (ListImportRowsStatusEnum) {
    ListImportRowsStatusEnum["Validating"] = "validating";
    ListImportRowsStatusEnum["Validated"] = "validated";
    ListImportRowsStatusEnum["Importing"] = "importing";
    ListImportRowsStatusEnum["Imported"] = "imported";
    ListImportRowsStatusEnum["RollingBack"] = "rolling_back";
    ListImportRowsStatusEnum["RolledBack"] = "rolled_back";
    ListImportRowsStatusEnum["Errored"] = "errored";
})(ListImportRowsStatusEnum = exports.ListImportRowsStatusEnum || (exports.ListImportRowsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ListImportsStatusEnum;
(function (ListImportsStatusEnum) {
    ListImportsStatusEnum["Validating"] = "validating";
    ListImportsStatusEnum["Validated"] = "validated";
    ListImportsStatusEnum["Importing"] = "importing";
    ListImportsStatusEnum["Imported"] = "imported";
    ListImportsStatusEnum["RollingBack"] = "rolling_back";
    ListImportsStatusEnum["RolledBack"] = "rolled_back";
    ListImportsStatusEnum["Errored"] = "errored";
})(ListImportsStatusEnum = exports.ListImportsStatusEnum || (exports.ListImportsStatusEnum = {}));
